import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';

// Campaña de recompra (sql/124).

// La campaña vigente (la más reciente que no ha terminado), o null.
export async function obtenerCampanaActiva() {
  const hoy = new Date();
  const ymd = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
  const { data, error } = await supabase.from('campanas_recompra').select('*')
    .eq('negocio_id', getNegocioId()).gte('hasta', ymd)
    .order('creado_en', { ascending: false }).limit(1);
  if (error) throw error;
  return (data || [])[0] || null;
}

export async function crearCampana({ nombre, descuentoPct, desde, hasta, mensajes }) {
  const { data, error } = await supabase.from('campanas_recompra').insert([{
    negocio_id: getNegocioId(), nombre: nombre.trim().slice(0, 80),
    descuento_pct: Number(descuentoPct) || 0, desde, hasta, mensajes: mensajes || {},
  }]).select().single();
  if (error) throw error;
  return data;
}

export async function actualizarCampana(id, cambios) {
  const fila = {};
  if (cambios.nombre !== undefined) fila.nombre = cambios.nombre.trim().slice(0, 80);
  if (cambios.descuentoPct !== undefined) fila.descuento_pct = Number(cambios.descuentoPct) || 0;
  if (cambios.hasta !== undefined) fila.hasta = cambios.hasta;
  if (cambios.mensajes !== undefined) fila.mensajes = cambios.mensajes;
  const { error } = await supabase.from('campanas_recompra').update(fila).eq('id', id);
  if (error) throw error;
}

export async function obtenerEnvios(campanaId) {
  const { data, error } = await supabase.from('campana_envios').select('cliente_id, grupo, enviado_en').eq('campana_id', campanaId);
  if (error) throw error;
  return data || [];
}

export async function marcarEnviado(campanaId, clienteId, grupo) {
  const { error } = await supabase.from('campana_envios')
    .upsert([{ campana_id: campanaId, cliente_id: clienteId, negocio_id: getNegocioId(), grupo, enviado_en: new Date().toISOString() }],
      { onConflict: 'campana_id,cliente_id' });
  if (error) throw error;
}

export async function desmarcarEnviado(campanaId, clienteId) {
  const { error } = await supabase.from('campana_envios').delete().eq('campana_id', campanaId).eq('cliente_id', clienteId);
  if (error) throw error;
}

// Ventas con cliente + categoría y talla del producto (de 1000 en 1000).
export async function obtenerVentasConProducto() {
  const neg = getNegocioId();
  let desde = 0; let todas = []; let seguir = true;
  while (seguir) {
    const { data, error } = await supabase.from('ventas')
      .select('cliente_id, ticket_id, nombre_producto, vendido_en, total, productos ( categoria, talla )')
      .eq('negocio_id', neg).not('cliente_id', 'is', null)
      .order('vendido_en', { ascending: false }).range(desde, desde + 999);
    if (error) throw error;
    todas = todas.concat((data || []).map((v) => ({ ...v, categoria: v.productos?.categoria || null, talla: v.productos?.talla || null })));
    desde += 1000;
    seguir = (data || []).length === 1000 && desde < 50000;
  }
  return todas;
}
